import { OdinDataSort } from '@myosh/odin-components';

export const getSortedFields = (sortedFields: Record<string, OdinDataSort>) => {
  const sortField = Object.keys(sortedFields);

  if (sortField.length >= 1) {
    const sortOrder = sortedFields[sortField[0]].direction.toUpperCase();
    return {
      sort: encodeURIComponent(sortField[0]),
      orderBy: sortOrder,
    };
  }
  return {
    sort: '',
    orderBy: '',
  };
};
